import { useContext } from 'react';
import { useStore } from 'zustand';
import { MultiChatContext } from './context';
import { MultiChatStore } from './types';
import { ExtractState } from '../../Chat/hooks/types';

/**
 * Returns a selected part of the chat store.
 * @example const setResponses = useChatStoreExtract(state => state.setResponses)
 * @param selector A callback where you can specify which part of the store you need. It's a common practice to slim down to a single element you need.
 * @returns The selected part of the store
 */
export function useMultiChatStoreExtract<U>(
  selector: (state: ExtractState<MultiChatStore>) => U,
): U {
  const multiChatStoreInstance = useContext(MultiChatContext);
  if (!multiChatStoreInstance?.current)
    throw Error('You have to wrap Chat component into MultiChatStoreContextProvider');
  return useStore(multiChatStoreInstance.current, selector);
}
